import { useTranslation } from 'react-i18next';
import {
  KYC_DOCUMENT_TYPES,
  SocialSecurityCardDocument,
} from '../util/constants';
import IdCardIcon from '../components/Icons/IdCardIcon';
import CheckIcon from '../components/Icons/CheckIcon';
import { PAGES } from '../constants/pages';
import { getDocumentsByApplicantType } from '../util/helpers/kycDocumentsFiltering';

const useKycProofOfSocialSecurityDocuments = (
  requiredDocuments,
  applicantType,
) => {
  const { t } = useTranslation();

  const getPath = (value) =>
    PAGES.KYC_PROOF_OF_SOCIAL_SECURITY[String(applicantType).toUpperCase()]
      .UPLOAD[value];

  const getSocialSecurityDocuments = (documents) => {
    const documentsByApplicantType = getDocumentsByApplicantType(
      documents,
      applicantType,
    );

    return documentsByApplicantType.filter(
      (document) =>
        [SocialSecurityCardDocument].indexOf(
          KYC_DOCUMENT_TYPES[`${document.DocumentType}`],
        ) > -1,
    );
  };

  const filterResidencyDocumentsBasedOnType = (documents) =>
    documents.flatMap((document) => {
      switch (KYC_DOCUMENT_TYPES[`${document.DocumentType}`]) {
        case SocialSecurityCardDocument:
          return [
            {
              ...document,
              title: t('kycVerification.socialSecurityCard'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              path: getPath('SOCIAL_SECURITY_CARD'),
            },
          ];
        default:
          return [];
      }
    });

  const kycSocialSecurityOptions = () => {
    if (!requiredDocuments.length) return;

    const socialSecurityDocuments = getSocialSecurityDocuments(
      requiredDocuments,
    );

    const documents = filterResidencyDocumentsBasedOnType(
      socialSecurityDocuments,
    );

    return documents;
  };

  return { kycSocialSecurityOptions };
};

useKycProofOfSocialSecurityDocuments.propTypes = {};

export default useKycProofOfSocialSecurityDocuments;
